import React, { useState, useEffect } from "react";
import axios from "axios";

// Components
import Preloader from "../../../components/Preloader/Preloader";

import MUIDataTable from "mui-datatables";
import Autocomplete from "@material-ui/lab/Autocomplete";
//Date Range
import { addDays, format } from "date-fns";
import { DateRangePicker } from "materialui-daterange-picker";

import { TableFooter, TableRow, TableCell } from "@material-ui/core";
// Material UI Component
import {
  FormGroup,
  FormLabel,
  FormControl,
  // ListItemText,
  TextField,
  // Checkbox,
  // FormControlLabel,
  Grid,
  Select,
  InputLabel,
  Input,
  // MenuItem,
  Modal,
  Backdrop,
  Fade,
  FormHelperText,
  NativeSelect,
  Button,
} from "@material-ui/core";
import {
  makeStyles,
  createMuiTheme,
  MuiThemeProvider,
} from "@material-ui/core/styles";
// Material Icons
import { AssessmentTwoTone } from "@material-ui/icons";
import { useParams, NavLink } from "react-router-dom";

//Material UI Icons
import ArrowForwardIosIcon from "@material-ui/icons/ArrowForwardIos";
import { get_cookies, isLoggedIn } from "../../../components/Cookies/Cookies";
// import DeleteSystemUser from './DeleteSystemUser';
// import AddSystemUser from './AddSystemUser';
// import UpdateSystemUser from './UpdateSystemUser';
import MessageBox from "../../../components/MessageBox/MessageBox";

const useStyles = makeStyles((theme) => ({
  modal: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
}));

const ProductPackageView = () => {
  const [posts, setPosts] = useState([]);
  const { id } = useParams();
  const [dataLoaded, setDataLoaded] = useState(false);
  const [open, setOpen] = useState(false);
  const [modalOpen, setModalOpen] = useState(false);
  const [dateRange, setDateRange] = useState({
    startDate: new Date(),
    endDate: addDays(new Date(), 7),
  });
  const classes = useStyles();
  const [downloadFlag, setDownloadFlag] = useState(false);
  //Message Box
  const [showMsgBox, setShowMsgBox] = useState(false);
  const [packageItem,setPackageItem] = useState({});
  const [grandTotal, setGrandTotal] = useState(0.0);
  const [msgBoxContent, setMsg] = useState("Empty");
  const [msgType, setMsgType] = useState("success");
  //Message Box EOF

  // Data Fetching
  useEffect(() => {
    data();
  }, []);

  const x = 0;
  useEffect(() => {
    //
    isLoggedIn();
    dataFilter();
  }, [x]);

  useEffect(() => {
    if (posts.length > 0) {
      setDownloadFlag(true);
    } else {
      setDownloadFlag(false);
    }
  }, [posts]);

  //search button
  const dataFilter = async () => {
    await axios
      .get(process.env.REACT_APP_API_URL + "get_product_package_view", {
        params: {
          jc_u_idno: get_cookies("branchidno"),
          packageid: id, //pass the main_nav_id from cookies to get data from api param example: "1,2,3,4,5,6,7,8"
        },
      })
      .then(function (res) {
        console.log("res", res);
        setPosts(res.data.data);
        setGrandTotal(res.data.grandtotal);
	setPackageItem(res.data.packagename);
      })
      .catch(function (error) {
        console.log(error);
      });
  };

  const data = async () => {
    setDataLoaded(true);
  };

  const toggle = () => setOpen(!open);

  const handleModalOpen = () => {
    setModalOpen(true);
  };

  const handleModalClose = () => {
    setModalOpen(false);
  };

  const dateRangeHandler = (range) => {
    setDateRange(range);
    setOpen(false);
  };

  const showModal = (message, type) => {
    setShowMsgBox(true);
    setMsgType(type); //success or warning
    setMsg(message);
    dataFilter();
    setTimeout(() => {
      setShowMsgBox(false);
      dataFilter();
    }, 2000);
  };

  const getMuiTheme = () =>
    createMuiTheme({
      overrides: {
        MUIDataTableHeadCell: {
          root: {
            "&:nth-child(1)": {
              width: 600,
            },
            "&:nth-child(2)": {
              width: 600,
            },
            "&:nth-child(3)": {
              width: 250,
            },
          },
        },
      },
    });

  const columns = [
    {
      name: "itemid",
      label: "ID",
    },
    {
      name: "itemname",
      label: "Item Name",
    },
    {
      name: "qty",
      label: "Qty",
    },
    {
      name: "uom_description",
      label: "Unit",
    },
    {
      name: "itemprice",
      label: "Price",
    },
    {
      name: "rowtotal",
      label: "Total",
    },
  ];

  const options = {
    filter: false,
    filterType: "dropdown",
    selectableRows: "none",
    // filterType: "multiselect",
    responsive: "standard",
    download: false, //add this
    print: false, //add this
    setFilterChipProps: (colIndex, colName, data) => {
      //console.log(colIndex, colName, data);
      return {
        color: "primary",
        variant: "outlined",
        className: "testClass123",
      };
    },
    downloadOptions: {
      filename: "ProductPackageView.csv", //change filename of csv
    },

    // tableBodyHeight,
  };

  const style = {
    marginBottom: "1rem",
    // marginTop:"2.5em",
  };

  return (
    <div className="page">
      <div className="page-header">
        <div className="page-icon">
          <AssessmentTwoTone />
        </div>
        <NavLink to={"/settings"}>
          <h4 style={{ color: "#1D1C1A" }}>Settings</h4>
        </NavLink>
        <ArrowForwardIosIcon
          style={{ paddingLeft: "10px", paddingRight: "10px" }}
        />
          <NavLink to={"/settings/product-package"}>
          <h4 style={{ color: "#1D1C1A" }}>Product Package</h4>
        </NavLink>
      </div>
      <div className="page-container">
        <MessageBox in={showMsgBox} content={msgBoxContent} type={msgType} />
        {!dataLoaded ? (
          <Preloader />
        ) : (
          <MuiThemeProvider theme={getMuiTheme()}>
            <MUIDataTable
              title={
                <div>
                
                  <div className="table-title">{packageItem.description}</div>
                </div>
              }
              data={posts}
              columns={columns}
              options={options}
            />
            <div
              colSpan={3}
              style={{
		alignItems:'right',
		marginTop:10,
                textAlign: "right",
                paddingRight: "16px",
                padding: "10px 20px",
                backgroundColor: "white",
                borderRadius: "5px",
                border: "1px solid #ccc",
                display: "inline-block",
                boxShadow: "0px 4px 6px rgba(0, 0, 0, 0.1)",
                cursor: "pointer",
              }}
            >
              <strong>Total Amount: {grandTotal}</strong>
            </div>
          </MuiThemeProvider>
        )}
      </div>
    </div>
  );
};

export default ProductPackageView;
